import { FieldValidator, useField, useFormikContext } from 'formik';
import { PostingsPageParamsDTO } from '../../data/dto/PostingsPageParamsDTO';
import { markSearchAsUserTriggered } from '../../data/LoadboardPostingAPI';
import {
  PostingSearchCriteriaVenueField,
  PostingSearchCriteriaVenueFieldProps,
} from './PostingSearchCriteriaVenueField';

interface FormPostingSearchCriteriaVenueFieldProps extends Omit<
  PostingSearchCriteriaVenueFieldProps,
  'value' | 'onChange' | 'onRecentClick' | 'searchCriteria'
> {
  name: string;
  validate?: FieldValidator;
}

export function FormPostingSearchCriteriaVenueField({
  name,
  validate,
  TextFieldProps,
  ...rest
}: FormPostingSearchCriteriaVenueFieldProps) {
  const { setFieldValue, values } = useFormikContext<PostingsPageParamsDTO>();
  const [field, { error }, { setValue }] = useField({ name, validate });
  return (
    <PostingSearchCriteriaVenueField
      {...rest}
      {...field}
      searchCriteria={values.search_criteria}
      onChange={(value) => {
        void setValue(value);
      }}
      onRecentClick={(value) => {
        void setFieldValue('search_criteria', markSearchAsUserTriggered(value));
      }}
      TextFieldProps={{
        ...TextFieldProps,
        error: !!error,
        helperText: error || TextFieldProps?.helperText,
      }}
    />
  );
}
